/**
 * External Imports
 */
import styled from 'styled-components';

export const SIDE_NAV_LABEL_MARGIN_RIGHT = '10rem';

export const SideNavLabel = styled.div`
  margin-right: ${SIDE_NAV_LABEL_MARGIN_RIGHT};
`;
